import Image from "next/image"
import upscbanner1 from "../../assets/images/home/Banner/UPSC-result-web-banner-2026.jpg";
// import phone from "../../assets/images/upsc/phone.png";
import styles from "../upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
const Acheiver = dynamic(()=>import("../../components/our-acheiver/achievers"));
const ObtionalButton = dynamic(()=>import("../../components/optionalbutton"));
const BranchAddress = dynamic(()=>import("../../components/branch-address"));
import Program_Features from "../upsc-admission-anna-nagar/upsc-ias-ips-admission-program-features";
import Classroom_form from "../upsc-admission-anna-nagar/upsc-ias-ips-admission-form";
import Upsc_popup from "../../assets/images/upsc/POPUP-June-GSPCM-BANG-PAGE.png";
import Close from "../../assets/images/home/Icon ionic-ios-close-circle.png";
import Modal from 'react-bootstrap/Modal';
import Link from "next/link";
import sadhana from "../../assets/images/upsc/sadhanaL-2.png";
import redrightarrow from "../../assets/images/contact/arrow.png";
import useDownloader from "react-use-downloader";
import downloadicon from "../../assets/images/download.png";
import Head from "next/head";
import Emioption from "../../components/Service/emioption";
import Optionalplus from "../../components/Service/optionalplus";
import { useEffect, useState } from 'react';
import { useRouter } from "next/router";
const UPSCClassroomOnline = () => {

  const {download} = useDownloader();

  const fileUrl = "/pdf/UPSC-2026/Brochure-bengaluru-admission-2026.pdf";
  const filename = "Brochure-bengaluru-admission-2026.pdf"
  const [modalIsOpen, setIsOpen] = useState(false);
  const closeModal = () => setIsOpen(false);
  const openModal = () => setIsOpen(true);
  
// useEffect(() => {
//   if (typeof window !== "undefined") {
//     const session = sessionStorage.getItem("notify");

//     if (!session) {
//       openModal();
//       sessionStorage.setItem("notify", "true");
//     }
//   }
// }, []);

const stats = [
    {
      value: "2700+",
      label: "IAS / IPS / IFS Selections Nationwide",
      sub: "Highest in India",
    },
    {
      value: "238 / 1009",
      label: "Selections in UPSC CSE 2024",
    },
    {
      value: "25",
      label: "Candidates in Top 100 Ranks",
    },
    {
      value: "8 States",
      label: "Government-Recognized Training Partner",
    },
  ];

  const steps = [
  
  {
    title: "Classroom Teaching",
    desc: "900+ hours of comprehensive instruction",
  },
  {
    title: "Individual Mentoring",
    desc: "100+ hours of one-on-one guidance",
  },
  {
    title: "Test Series",
    desc: "Extensive prelims and mains mock tests with detailed evaluation",
  },
  {
    title: "Study Materials",
    desc: "Updated, curated content reflecting latest UPSC trends",
  },
   {
    title: "Interview Preparation",
    desc: "Free guidance program for Mains qualifiers",
  },
];


  const feestructure =[
    // {date:"23.01.2026", cont:"Regular", cont1:"11:00 am to 01:30 pm"},
    {date:"16.02.2026", cont:"Regular", cont1:"11:00 am to 01:30 pm"},
    {date:"06.04.2026", cont:"Regular", cont1:"11:00 am to 01:30 pm"},
    {date:"24.06.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
    
  ]

  const feestructure2 =[
    {date:"23.08.2026",cont:"Weekend",cont1:"09:00 am to 01:00 pm"},
  ]

  const feestructure3 =[

    {date:"04.07.2026",cont:"Weekend",cont1:"Mathematics",cont2:"08:30 am to 01:30 pm"},
    {date:"05.07.2026",cont:"Weekend",cont1:"Public Administration",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2026",cont:"Weekend",cont1:"Geography",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2026",cont:"Weekend",cont1:"Tamil literature",cont2:"09:00 am to 01:00 pm"},
    {date:"12.07.2026",cont:"Weekend",cont1:"History",cont2:"09:00 am to 01:00 pm"},
    {date:"25.07.2026",cont:"Weekend",cont1:"Psychology",cont2:"09:00 am to 01:00 pm"},
    {date:"01.08.2026",cont:"Weekend",cont1:"Economics",cont2:"09:00 am to 01:00 pm"},
    {date:"17.08.2026",cont:"Regular",cont1:"PSIR",cont2:"05:30 pm to 08:00 pm"},
    
    {date:"06.07.2026",cont:"Regular",cont1:"Anthropology",cont2:"02:30 pm to 04:30 pm"},
    {date:"20.07.2026",cont:"Regular",cont1:"Agriculture",cont2:"06:30 pm to 08:30 pm"},
    {date:"24.07.2026",cont:"Regular",cont1:"Sociology",cont2:"05:00 pm to 07:30 pm"},
    {date:"14.08.2026",cont:"Regular",cont1:"English",cont2:"02:30 pm to 05:00 pm"},
    {date:"14.09.2026",cont:"Regular",cont1:"Law",cont2:"02:30 pm to 05:00 pm"}
        

  ]
     
  const jsonLd ={
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "IAS Coaching in Bangalore | Shankar IAS Academy",
    "url": "https://www.shankariasacademy.com/bengaluru/",
    "Image":
    "https://www.shankariasacademy.com/_next/static/media/Pre-book-2024_Webbanner-Without-button.6686241b.webp",
    "description": "Transform your IAS dreams into reality with Top IAS Coaching in Bangalore. Expert guidance, comprehensive curriculum, and proven success awaityou."
  }


  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url) => {
      console.log(`Navigated to ${url}`);
      router.reload(); // Refresh the page on route change
    };

    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);
 const [show, setShow] = useState(false);

  useEffect(() => {
    // Runs after every page load / refresh
    setShow(true);
  }, []);
    return (
      <>
    <Head>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
      <meta charset="UTF-8" /> 
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="robots" content="noodp,noydir" />
      <meta name="robots" content="index,follow" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
      <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
      <title> Best IAS Coaching in Bangalore | UPSC Classes | Shankar IAS Academy</title>
      <meta name="title" content=" Best IAS Coaching in Bangalore | UPSC Classes | Shankar IAS Academy" />
      <meta name="description" content="Join Shankar IAS Academy Bangalore.  238 UPSC selections in 2024, 900+ teaching hours, expert faculty. Enroll in our Foundation Course. Limited seats!" />
      <link rel="canonical" href="https://www.shankariasacademy.com/bengaluru/" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content=" Best IAS Coaching in Bangalore | UPSC Classes | Shankar IAS Academy" />
      <meta property="og:description" content="Join Shankar IAS Academy Bangalore.  238 UPSC selections in 2024, 900+ teaching hours, expert faculty. Enroll in our Foundation Course. Limited seats!" />
      <meta property="og:url" content="https://www.shankariasacademy.com/bengaluru/" />
      <meta property="og:site_name" content="Shankar IAS Academy" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@shankarias" />
      <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script>
    </Head>

     <Modal
      size="md"
      centered
      show={show}
      onHide={() => setShow(false)}
      aria-label="UPSC Modal"
      className="blur"
    >
    <Modal.Body className="p-0">
      <div className="position-absolute  p-0 p-md-1 closebtn">
        <Image loading="eager" placeholder="blur" onClick={() => setShow(false)} alt="Close icon" title="Close modal" src={Close} className="img-fluid" style={{ cursor: "pointer", width: "20px" }} />                 
      </div>
      <Link
        href="#gspcm"
        className={`${styles.acheiverrank, styles.courseshover2}`}
        id="" 
        onClick={() => setShow(false)}
      >
        <Image src={Upsc_popup} alt="Modal Banner" className="img-fluid w-100"  useMap="#image-map"/>                    
      </Link> 
    </Modal.Body>
    </Modal>   

  <Navbar title="upsc" />

  <div className="container">
    <div className="row">
      <div className="col pt-3 pt-md-4">
        <div className={`${styles.tabscrollclass} nav nav-pills align-items-baseline`}>
          <Link href="/upsc-admission-anna-nagar"><button id={styles.tablinks} className="nav-link tab1 py-2 px-0 me-4 " type="button">Anna Nagar</button></Link>
          <Link href="/adyar"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Adyar</button></Link>
          <Link href="/bengaluru"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4 active" type="button">Bengaluru</button></Link>
          <Link href="/coimbatore"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Coimbatore</button></Link>
          <Link href="/delhi"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Delhi</button></Link>
          <Link href="/hyderabad"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Hyderabad</button></Link>
          <Link href="/thiruvananthapuram"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Thiruvananthapuram</button></Link>
          <Link href="/trichy"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Trichy</button></Link>
          <Link href="/salem"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Salem</button></Link>
          <Link href="/madurai"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Madurai</button></Link>
          <Link href="/upsc-online-class"><button id={styles.tablinks} className="nav-link tab10 py-2 px-0 me-4" type="button">Online Class</button></Link>
          <Link href="/upsc-admission-nri"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">NRI</button></Link>
        </div>
      </div>
    </div>
  </div>
               
  <div className="container">
    <div className="row">
      <div className="col pt-3 pt-md-4">
        <h1 className={`${styles.pagemaintitle}`}>UPSC Coaching in Bangalore Your Path to Civil Services Success</h1>
       
        <Image
          src={upscbanner1}
          className="img-fluid w-100 pt-2"
          alt="Classroom and online coaching"
          title="Classroom and online coaching"
        />
      </div>
    </div>
  </div>

{/*<Classroom_form branchname="Bengaluru"/>*/}
<div className="container ">
  <div className={`${styles.coursesimg} mb-2`}>
    <div class="col-12 col-md-6 offset-md-3 mt-4">
      <p className={`${styles.contactheader} text-center`}>Enquiry</p>
      <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
      <div class={`${styles.addmissionform} npf_wgts mt-2`} data-height="550px" data-w="3f4274baec4df825dd72c5ff92d085ff"> </div> 
    </div>
  </div>
</div>

 <section className="d-none d-md-block py-5 bg-light">
      <div className="container">
        <div className={`${styles.csatborder}`}>
          <p className={`${styles.acheiverrank} pt-4 text-center`}> <span style={{ color: "#db1b0d" , fontWeight:"bold" }}>Shankar IAS Academy </span>has been Bangalore's most trusted name in UPSC preparation since 2004. Founded by<span style={{ color: "#0a0101" , fontWeight:"bold" }}> Mr. Shankar D., </span>our Bangalore center has helped thousands of aspirants transform their IAS dreams into reality</p>
          <p className="text-center fw-bold mb-4 ">
           <span style={{fonts:"bold" }}> Our Track Record Speaks for Itself </span>
          </p>

        <div className="row g-4 justify-content-center pt-3">
          {stats.map((item, index) => (
            <div key={index} className="col-12 col-sm-6 col-lg-3">
              <div className= {`${styles.statcircle} text-center mx-auto`}>
                <h3 className=" mb-2">{item.value}</h3>
                <p className="mb-1 fw-semibold">{item.label}</p>
                {item.sub && (
                  <small className="text-muted">{item.sub}</small>
                )}
              </div>
            </div>
          ))}
        </div>
        </div>
      </div>
</section>

 <section className="d-block d-md-none bg-light">
  <div className="container">
    <div className="row g-4 justify-content-center ">
      <div className="">
          <p className={`${styles.acheiverrank} pt-4 text-center`}> <span style={{ color: "#db1b0d" , fontWeight:"bold" }}>Shankar IAS Academy </span>has been Bangalore's most trusted name in UPSC preparation since 2004. Founded by<span style={{ color: "#0a0101" , fontWeight:"bold" }}> Mr. Shankar D., </span>our Bangalore center has helped thousands of aspirants transform their IAS dreams into reality</p>
          <p className="text-center fw-bold mb-4 ">
           <span style={{fontSize:"16px" }}> Our Track Record Speaks for Itself </span>
          </p>
          <div className="card shadow-sm p-4">
            <ul>
              <li>2700+ IAS/IPS/IFS selections nationwide (highest in India)</li>
              <li>238 out of 1009 selections in UPSC CSE 2024</li>
              <li>25 candidates in Top 100 ranks</li>
              <li>Government-recognized training partner across 8 states</li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</section>


<div className="container-fluid mt-4 pt-5 pb-3">
  <div className={`${styles.bestbg1}`}>
    <div className="row g-4 mt-2">
      <div className="col-12 col-md-6 col-lg-12">
         <div className="card shadow-sm pt-4">
            <h2>Pre Booking Open</h2> 
            <p>
              For pre-booking, contact the number - <span style={{color:'#db1b0d' }}>72593 23266 | 080-23383121 | 81972 92121</span> 
            </p>
            <div className={`${styles.brochure} pb-3 justify-content-center`}>
              <a href="https://www.shankariasacademy.com/pdf/UPSC-2026/Brochure-bengaluru-admission-2026.pdf" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.normalbutton1} btn btn-danger`}>
                  <Image src={downloadicon} alt="download icon" /> UPSC GSPCM 2026 (Brochure)
                </button>
              </a>
            </div> 
         </div>   
      </div>            
    </div>
  </div>
</div>

{/* Fee Details Section */}

  <div className="container">
      <div className="row pt-2">

      {/* <div className={`${styles.brochure}`}>
      <h2 className={`${styles.sectiontitle} pt-3`}>Course and Fees</h2>
      <button className={`${styles.normalbutton2} ${styles.brochurebtn}`} onClick={() => download(fileUrl, filename)}>
        <Image src={downloadicon} alt="download icon" />
        <p className={`${styles.brochuretxt}`}>Download Brochure</p>
      </button>
      </div> */}
    
      <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12 " id="gspcm">
        <div className="row p-2">
          <div className={`${styles.csatborder} col-lg-8`} >
            <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>General Studies</p>
            <p className={`${styles.sectionsubtitle} mx-3`}>(Preliminary Cum Mains)</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>1,00,000</span><span style={{verticalAlign: "top"}}>(inclusive of tax)</span></span>
          </div>

          <div className={`${styles.csatborder} col-lg-4 pt-4`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>
         
      <div className="pt-3">       
        <div className="row mx-auto">
          <div className="col ps-0">
          <table className="table ">
            <tbody>
            {feestructure.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
              </tr>
              ))}
              <tr>
              {/* <td colSpan="4" className={`${styles.classacheiverrank} mb-0`}><b>(Video Conference)</b></td> */}
              </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>

      </div>
    

      <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
         <div className="row p-2">
          <div className={`${styles.csatborder} col-6 col-lg-8`} >
            <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>CSAT</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>14,000</span><span style={{verticalAlign: "top"}}>(inclusive of tax)</span></span>
          </div>

          <div className={`${styles.csatborder} col-6 col-lg-4 pt-4`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>
          

      <div className="pt-3">       
        <div className="row mx-auto">
          <div className="col ps-0">
          <table className="table ">
            <tbody>
            {feestructure2.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
              </tr>
              ))}
            <tr>
             
            </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>

      </div>

      <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
        <div className="row p-2">
          <div className={`${styles.csatborder} col-6 col-lg-8`} >
            <p className={`${styles.sectionsubtitle}  mb-0 mx-3`}>Optional</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>34,000</span></span>
          </div>

          <div className={`${styles.csatborder} col-6 col-lg-4 pt-4`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>


        <div className="pt-3" id="paymentsection">       
         <div className="row mx-auto">
          <div className="col ps-0 ps-xl-0 p-xl-0">
            <div className="table-responsive text-nowrap">
          <table className="table ">
            <tbody>
            {feestructure3.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont2}</td>
              </tr>
              ))}
              <tr>
               {/* <td colSpan="4" className={`${styles.classacheiverrank} mb-0`}><b>Forestry and Geology - After Prelims Result</b></td> */}
              </tr>
              <tr>
          
              </tr>
            </tbody>
          </table>
          </div>
          </div>   
        </div>
      </div>
     
      </div> 

      <div className="col-xl-3 offset-xl-8 col-lg-4 col-md-6 col-8  text-end pb-2 ">
        <ObtionalButton />
      </div>

      <div className={`${styles.facultyborder3} row p-4 h-100 mb-md-3`}>
          <div className="col-xl-3 col-lg-4 col-md-6 col-12">
            <p className={`${styles.sectionsubtitle} mb-0`}>GSPCM+CSAT+Optional</p>
            <p className={`${styles.sectionsubtitle} pb-0`}>Total Amount</p>
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <span className={`${styles.acheiverrank}`}> <span className={`${styles.sectionredtitle} `}><b>₹</b>1,48,000*</span><span>(inclusive of tax)</span></span>
          </div>
          <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2  text-right">
              <Emioption />
          </div>

          <div className="col-xl-3 col-lg-4 col-md-6 col-12  text-right pt-xl-0 pt-3">
            <a href="https://admissionsv1.shankariasacademy.com/?center=BENGALURU&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.normalbutton}`}>Pay Here</button></a>
          </div>
      </div>
  
     {/* <div className="row pt-3">
         <a href="https://admissionsv1.shankariasacademy.com/Prebooking-Forms/Step1/step1?center=ANNA_NAGAR&&course=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.normalbutton}`}>Pre Booking</button></a>
          <button type="button" className={`${styles.normalbutton} ms-3`} onClick={()=>router.push({pathname:"/Prebooking-Forms/Step1/step1",query:"center=ANNA NAGAR&course=UPSC"
             })}>Pre Booking</button> 
              <button type="button" className={`${styles.normalbutton} ms-3`}>Pre Booking</button> 
     </div> */}
  
     
     {/* <div className="row">
      <div className="col-md-12 col-lg-8 col-xl-8 col-12 pt-3 pe-xl-0">
      <p className={`${styles.aboutparagraph1} p-2`}> <span className={`${styles.dot} pe-2`}>*</span>&nbsp;<b>₹4,000</b> Discount will be applicable for Integrated Course payment <b>(GS + CSAT + Optional)</b></p>
      </div>
      <div className="col-md-12 col-lg-6 col-xl-4 col-12 pt-3 ps-xl-0">
      <p className={`${styles.aboutparagraph1} p-2`}> <span className={`${styles.dot} pe-2`}>*</span>&nbsp;Fees are inclusive of GST & SIA study materials.</p>
      </div>
     </div> */}

    </div>
  </div> 


<div className={`${styles.sadhana}`}>
  <div class="container">
    <div className="row">
      {/* <div className="col-12 col-md-4 text-white mt-2 p-2">UPSC GS-Mains Test Series 2025 (Moksha)<br /><a href="/upsc-mains-test-series/" className={`${styles.normalbutton} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`}> Click here <span></span></a></div> */}
      <div className="col-12 offset-md-4 col-md-4 p-2">
      <Link href="/two-year-upsc-program">
        <Image alt="sadhana" className="img-fluid" src={sadhana} />
      </Link>
      </div>

      {/* <div className="col-12 col-md-4 text-white mt-2 p-2 order-first order-md-last">UPSC GSPCM 2025 (Brochure)<br />
      <button className={`${styles.normalbutton2} ${styles.brochurebtn} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`} onClick={() => download(fileUrl, filename)}>
          <p className=""> <Image src={downloadicon} alt="download icon" /> Download Brochure</p>
        </button>
      </div> */}
    </div>
  </div>
</div>

<Program_Features />

<section id="courses">
  <div className="container-fluid">
    <div className={`${styles.bestbg}`}>
      <h2 className="text-center">Why Aspirants Choose Shankar IAS Academy in Bangalore</h2>
      <div className="row g-4 mt-2">
        <div className="col-12 col-md-6 col-lg-12">
          <div className="card shadow-sm p-4">
            <div className="card-icon">
              <i className="fas fa-chalkboard-teacher"></i>
            </div>
            <h3>Expert Faculty with Proven Results</h3>
            <p>
              Our teaching team comprises handpicked educators from premier institutions and universities. Each faculty member brings years of experience in UPSC coaching, subject expertise, and a passion for mentoring future civil servants.
            </p>
          </div>
        </div>

         <div className="col-12 col-md-6 col-lg-12">
          <div className="card shadow-sm p-4">
            <div className="card-icon">
              <i className="fas fa-book-open"></i>
            </div>
            <h3>Comprehensive 360-Degree Preparation</h3>
            <p>
               We guide you through every stage of the UPSC journey:
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span> <span style={{fontWeight:'600'}}>Prelims Preparation  –</span> Conceptual clarity with extensive MCQ practice </li>
              <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span> <span style={{fontWeight:'600'}}>Mains Answer Writing  – </span> Structured techniques for high-scoring answers</li>
              <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span><span style={{fontWeight:'600'}}> Current Affairs Integration –</span>Daily analysis aligned with UPSC patterns</li>
              <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span><span style={{fontWeight:'600'}}> Interview Guidance  –</span>  Mock interviews with retired civil servants and experts</li> 
            </ul>
          </div>
        </div>
       
        <div className="col-12 col-md-6 col-lg-12">
          <div className="card shadow-sm p-4">
            <div className="card-icon">
              <i className="fas fa-users"></i>
            </div>
            <h3>Interactive Learning Methodology</h3>
            <p>
              Our classroom sessions go beyond passive lectures. We use participatory teaching methods that encourage discussion, debate, and critical thinking skills essential for both Mains and the Personality Test.
            </p>
          </div>
        </div>
       
        <div className="col-12 col-md-6 col-lg-12">
          <div className="card shadow-sm p-4">
            <div className="card-icon">
              <i className="fas fa-book-open"></i>
            </div>
            <h3>Personalized Attention</h3>
            <p>
              With limited batch sizes and an optimal student-faculty ratio, every aspirant at Shankar IAS Academy receives individual mentoring. No student is left behind.
            </p>
            
          </div>
        </div>

      <h2 className="text-center">What Makes Our Bangalore Centre Unique (Visualization)</h2>

        <div className="position-relative mx-auto" style={{ maxWidth: "600px" }}>
          {/* Center vertical line */}
          <div
            className="position-absolute top-0 start-50 translate-middle-x"
            style={{ width: "4px", height: "95%", background: "#c3c9cf" }}
          ></div>

          <ul className="list-unstyled m-0 p-0">
            {steps.map((step, index) => (
              <li key={index} className="position-relative mb-5">
                {/* Circle connector */}
                <div
                  className="position-absolute start-50 translate-middle rounded-circle shadow"
                  style={{
                    width: "40px",
                    height: "40px",
                    top: "0",
                    background: "#c50101",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    zIndex: 1,
                  }}
                >
                  ✓
                </div>

                {/* Card */}
                <div
                  className="bg-white shadow p-4 rounded-3 text-center mx-auto"
                  style={{ width: "90%", marginTop: "20px" }}
                >
                  <h6 className="fw-bold text-dark">{step.title}</h6>
                  <p className="text-muted mb-0">{step.desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-12 col-md-6 col-lg-12">
            <div className="card shadow-sm p-4">
              <div className="card-icon">
                <i className="fas fa-book-open"></i>
              </div>
              <h3>Beyond UPSC – Multi-Exam Preparation</h3>
              <p>
              The knowledge and analytical skills you gain at Shankar IAS Academy prepare you for more than just the Civil Services Examination. Our students have successfully cleared:
              </p>
              <ul className="list-group list-group-flush">
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span> Indian Forest Services (IFS)</li>
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span> State Public Service Commissions (KPSC, TNPSC, APPSC)</li>
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span> SSC CGL and other competitive examinations</li>
              </ul>
            </div>
        </div>

        <div className="col-12 col-md-6 col-lg-12">
            <div className="card shadow-sm p-4">
              <div className="card-icon">
                <i className="fas fa-book-open"></i>
              </div>
              <h3>Our Philosophy – Building Future Leaders</h3>
              <p>
                At Shankar IAS Academy, we believe that becoming an IAS officer is not just about clearing an exam – it's about becoming a responsible leader who serves the nation. Our curriculum focuses on developing:
              </p>
              <ul className="list-group list-group-flush">
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span>In-depth subject knowledge</li>
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span>Ethical reasoning and integrity</li>
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span>Analytical and decision-making skills</li>
                <li className="list-group-item"><span className={`${styles.dot1} pe-2`}>*</span>Empathy and public service orientation</li>
              </ul>
            </div>
        </div>
      </div>
    </div>
  </div>
</section>

{/* Our Acheivers */}
  <div className="container">
    <div className="row">
      <div className="col pt-4 pt-md-5 text-center">
          <h2 className={`${styles.sectiontitle} mb-0`}>Our Achievers</h2>
          <p className={`${styles.sectionsubtitle}`}>
            Rank Holders from our academy
          </p>
      </div>
    </div>
  </div>

  <Acheiver />

  <section id="toppers">
    <div className="container">
      <div className="row">
        <div className="col-xl-12 col-lg-6 mb-3 mb-md-4 col-12 ">
          <Optionalplus /> 
        </div>
      </div>
    </div>
  </section>

  <section id="courses">
    <div className="container-fluid">
      <div className={`${styles.bestbg}`}>
        <div className="col-lg-12 pt-4">
          <div className="bg-white rounded-4 shadow-sm p-4 p-md-5">
              <h2 className={`${styles.pagemaintitle} mb-4`} style={{ color: "#7f0801" }}>
                Frequently Asked Questions
              </h2>
              <div className="accordion accordion-flush" id="imtTopFAQ">
                {/* FAQ 1 */}
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button className="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#faqOne" >
                      1. What is the fee structure for UPSC coaching at Shankar IAS Bangalore?
                    </button>
                  </h2>
                  <div id="faqOne" className="accordion-collapse collapse" data-bs-parent="#imtTopFAQ">
                    <div className="accordion-body">
                      Our General Studies Prelims cum Mains (GSPCM) course is priced at ₹1,00,000 (inclusive of taxes). CSAT is ₹14,000, and Optional subjects are ₹34,000. Combined packages are available at ₹1,48,000.
                    </div>
                  </div>
                </div>
      
                {/* FAQ 2 */}
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed fw-semibold"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqTwo"
                    >
                      2. What are the batch timings available?
                    </button>
                  </h2>
                  <div id="faqTwo" className="accordion-collapse collapse" data-bs-parent="#imtTopFAQ">
                    <div className="accordion-body">
                      We offer flexible Regular and Weekend batches. Regular batches run from 11:00 AM to 1:30 PM or 8:00 AM to 10:30 AM. Weekend batches are scheduled from 9:00 AM to 1:00 PM.
                    </div>
                  </div>
                </div>
      
                {/* FAQ 3 */}
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed fw-semibold"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqThree"
                    >
                    3. Which optional subjects are offered at the Bangalore center?
                    </button>
                  </h2>
                  <div id="faqThree" className="accordion-collapse collapse" data-bs-parent="#imtTopFAQ">
                    <div className="accordion-body">
                      We offer coaching for Geography, Psychology, Mathematics, Economics, History, Public Administration, Sociology, Anthropology, Agriculture, English, Law, PSIR, and Kannada.
                    </div>
                  </div>
                </div>
      
                {/* FAQ 4 */}
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed fw-semibold"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqFour"
                    >
                      4.How can I enroll at Shankar IAS Academy Bangalore?
                    </button>
                  </h2>
                  <div id="faqFour" className="accordion-collapse collapse" data-bs-parent="#imtTopFAQ">
                    <div className="accordion-body">
                      You can pre-book your seat by calling 72593 23266, 080-23383121, or 81972 92121. Walk-ins are also welcome at our Bangalore center.
                    </div>
                  </div>
                </div>
      
                {/* FAQ 5 */}
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed fw-semibold"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqFive"
                    >
                    5. Do you provide study materials?
                    </button>
                  </h2>
                  <div id="faqFive" className="accordion-collapse collapse" data-bs-parent="#imtTopFAQ">
                    <div className="accordion-body">
                      Yes. All enrolled students receive comprehensive, regularly updated study materials covering the complete UPSC syllabus, current affairs compilations, and previous year question analysis.
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section className={`${styles.ctaSection} py-5`}>
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-lg-10">

        <div className={styles.ctaCard}>
          <h2 className={`${styles.ctaTitle} text-center mb-3`}>
            Take the First Step Toward Your IAS Dream
          </h2>

          <p className={`${styles.ctaText} text-center mb-4`}>
            Join the academy that has produced more civil servants than any other institution in India. At <br/> <strong>Shankar IAS Academy Bangalore</strong>, your success is our mission.
          </p>

          <div className="row text-center g-3 mb-4">
            <div className="col-12 col-md-6">
              <div className={styles.contactBox}>
                <span className={styles.contactLabel}>Contact Us:</span>
                
                 Phone: 72593 23266 | 080-23383121 | 81972 92121
                
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className={styles.contactBox}>
                <span className={styles.contactLabel}>Visit Mail</span>
                
                Mail Id:  siabengaluru@shankariasacad.in
                
              </div>
            </div>
          </div>

          <div className={`${styles.visitNote} text-center`}>
            <strong>Visit Our Bangalore Center</strong>
            <p className="mb-0">
              Experience our teaching methodology firsthand. Walk in for a
              <span className={styles.highlight}> free counseling session</span>.
            </p>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>


  <BranchAddress />
  <Interest /> 
  <Footer />                        
      </>
    )
  }
  
  export default UPSCClassroomOnline;
